import { Colors, Themes } from "@polestar/component-warehouse-react";
import { extendTheme } from "@polestar/component-warehouse-react/themes/Theme";
export default extendTheme(Themes.light, {
    polestarApp: {
        backgroundColor: Colors.greyWhite,
    },
});
